import React from 'react';
import { CheckCircleFilled, WarningFilled } from '@ant-design/icons';
import { List } from 'antd';

import { Tooltip, Typography } from 'redpoints-front-components/index';

import { translate } from '../../../helpers/languageHelper';

const IconWithTooltip = ({ isSuccess, message }) =>
  isSuccess ? (
    <CheckCircleFilled className="row-status success" />
  ) : (
    <Tooltip
      placement="left"
      title={message ?? translate('error.something_wrong')}
      visible
    >
      <WarningFilled className="row-status error" />
    </Tooltip>
  );

const FacilitatorValidationContentLinksRow = ({ text, isSuccess, message }) => (
  <List.Item className="facilitator-validation-content-contentLinks-row">
    <List.Item.Meta description={<Typography>{text}</Typography>} />
    <IconWithTooltip isSuccess={isSuccess} message={message} />
  </List.Item>
);

export default FacilitatorValidationContentLinksRow;
